import find from 'lodash/find';

export class EditorTemplateService {
    constructor($resource, ApiService) {
        'ngInject';
        this.$resource = $resource;
        this.apiService = ApiService;
    }

    updatetEditorDetails(details, moduleName) {
        this._setResourceUrl(moduleName);
        const promise = this.editorEditResource.update({ content_id: details.id }, this._setMenuContentDetails(details)).$promise;

        return promise.then(details => details)
            .catch((error) => {
                throw this.apiService.getErrorMessage(error);
            });
    }

    getEditorContentDetailsObject(details, menuName) {
        return {
            menuOverviewDetails: this._getMenuOverviewDetails(details.data.menuOverviewDetails),
            menuContentDetails: this._getMenuContentDetails(find(details.data.content, ['name', menuName]).values[0])
        };
    }

// ***************************************************************Private Methods **************************************************************
    _setResourceUrl(moduleName) {
        this.editorEditResourceUrl = this.apiService.getResourceUrl(`cms/editor-content/${moduleName}/:content_id`);
        this.editorEditResource = this.$resource(this.editorEditResourceUrl, null, {
            update: {
                method: 'PUT'
            }
        });
    }

    _setMenuContentDetails(value) {
        return {
            description: value.description,
            images: value.images || [],
            videos: value.videos || []
        }
    }

    _getMenuOverviewDetails(details) {
        return {
            id: details.content_id,
            displayName: details.display_name,
            title: details.title,
            description: details.description,
            overview: details.overview,
            image: details.image,
            name: details.name,
            overview: details.overview
        }
    }

    _getMenuContentDetails(value) {
        return {
            id: value.content_id,
            description: value.description,
            images: this._getContentImagesObject(value.images) || [],
            videos: value.videos || []
        }
    }

    _getContentImagesObject(values) {
        return values ? values.map(({ uuid }) => ({ uuid, status: -1 })) : [];
    }
}


// WEBPACK FOOTER //
// ./src/app/components/editor-template/editor-template.service.js